import { pushNotificationActions } from "../../actionTypes";

const initialState = {
	pushNotifications: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case pushNotificationActions.FETCH_PUSH_NOTIFICATIONS: {
			return action.payload.reset
				? { ...initialState, fetching: true }
				: { ...state, fetching: true };
		}

		case pushNotificationActions.FETCH_PUSH_NOTIFICATIONS_FULFILLED: {
			return state.pushNotifications.current_page < action.payload.current_page
				? {
						...state,
						fetching: false,
						fetched: true,
						pushNotifications: {
							...action.payload,
							data: state.pushNotifications.data
								? [...state.pushNotifications.data, ...action.payload.data]
								: action.payload.data,
						},
				  }
				: {
						...state,
						fetching: false,
						fetched: true,
						pushNotifications: action.payload,
				  };
		}

		case pushNotificationActions.FETCH_PUSH_NOTIFICATIONS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
